// extracted by mini-css-extract-plugin
module.exports = {"teams":"Timeline_teams__1cVWK","events":"Timeline_events__1BYnT","marketingArchive":"Timeline_marketingArchive__6KCv6"};